import { render, staticRenderFns } from "./olympus1000.vue?vue&type=template&id=4f85b25e&scoped=true"
import script from "./olympus1000.vue?vue&type=script&lang=js"
export * from "./olympus1000.vue?vue&type=script&lang=js"
import style0 from "./olympus1000.vue?vue&type=style&index=0&id=4f85b25e&prod&scoped=true&lang=css"
import style1 from "./olympus1000.vue?vue&type=style&index=1&id=4f85b25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f85b25e",
  null
  
)

export default component.exports